import { render } from "./HomeHeroView.vue?vue&type=template&id=6f9e7b0c"
const script = {}

import exportComponent from "/home/derek/dev/nebula-networks-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__